import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { NoteComponentBase } from './note-component-base.js';

export class StaffNoteComponent extends NoteComponentBase {
  static readonly TYPE_ID: string = '8ba401dc1ccd487d997d1647a193158d';

  constructor(
      note: string,
  ) {
    super(note);
  }

  get $typeId(): string {
    return StaffNoteComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): StaffNoteComponent {
    return new StaffNoteComponent(
        MapUtils.get<string>(map, 'note'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'note': this.note,
    };
  }

  clone(): this {
    return new StaffNoteComponent(this.note) as this;
  }

  isSame(other: StaffNoteComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.note === this.note;
  }
}

export class StaffNoteComponentBuilder extends DataModelBuilder<StaffNoteComponent> {
  build(context: SerializationContext, map: SerializedData): StaffNoteComponent {
    return StaffNoteComponent.fromMap(context, map);
  }
}
